import React from 'react';
import {useState, useRef} from 'react'
import { makeStyles } from '@material-ui/styles';
import { Chip, List, Paper, Radio, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import IconButton from '@material-ui/core/IconButton';

import { priceFormat } from '../hooks/currency';

import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import {getOptionColor, getExtraPriceColor, getVariant, getCounterOptions} from '../hooks/additions'; 

const useStyles = makeStyles((theme) => ({

  content: {
    paddingBottom: theme.spacing(2), 
  },
  title: {
    paddingLeft: theme.spacing(2), 
    paddingRight: theme.spacing(2), 

    display: 'flex', 
    flexDirection:'column',
    justifyContent: 'flex-start', 
   
  },
  maximun: {
    display: 'flex', 
    flexDirection:'row',
    justifyContent: 'space-between', 
   
  },

  paper: {
    display: 'flex',
    alignItems: 'center',
    //marginLeft: theme.spacing(1), 
    //marginRight: theme.spacing(1), 
  },

  counter: {
    width:  '30%',
    minWidth:  '90px',
    display: 'flex',
    flexDirection:'row',
    justifyContent:'end',
    alignItems: 'center',
   // background: 'red'
  },

  optionText: {
    width:  '70%',
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    alignItems: 'center',
    justifyContent:'start',
    //marginRight: theme.spacing(1), 
    //background: 'green'
  },

  listItem: {
    display: 'flex',
    flexDirection:'space-between',
    alignItems: 'center',
    //background: 'blue'
  },

}));



export default function AdditionCounter(props) {
  const classes = useStyles();
  const {addition,showCurrency, store, order,strings, onChanges} = props; 
  const currency = store.currency; 

 // console.log('AdditionCounter, addition: ',addition);


  const options  = useRef(addition.options)
  const [disableOptions, setDisableOptions] = useState(false);
  const maxChecks = addition.maxOptions
  const maxStr = strings.additions_max_options.replace("${maxOptions}",maxChecks); 
 


  const getColorRequired=(optionsList)=>{
    let color = "accent"; 
    let counter=getCounterOptions(optionsList); 
    if(addition.type== "REQUIRED" && counter < 1){
        color = "error"; 
    }
    return color; 
  }

  const getStatus= (element)=>{
    const isChecked = element.counter>0;
    let variant = 'disable'
    if(isChecked) 
        variant = 'checked'
    else if(!disableOptions){
      variant = 'enable'
    }    
    return variant
  }

  const getExtraPrice = (value)=>{
    if(!value.price || value.price<=0.0)
      return ""
   return "+" + priceFormat(currency.style,value.price,showCurrency); 
  }
  
  const handlerOnChanges = (event,option)=>{
   if(onChanges){
     onChanges(event,option); 
   }
  }

  const handlerOnAddOption = (option,index)=>{
    //console.debug('handlerOnAddOption:',index);
    let counter = getCounterOptions(options.current)
    

    if(counter<maxChecks){
      const newOptions = [...options.current]; 
      let newCounter = option.counter ? option.counter:0; 
      newOptions[index]={
        ...option, 
        counter:newCounter+1
      }
      //console.debug('handlerOnAddOption,  newOptions:', newOptions);
      options.current = newOptions;
      const ad = { 
        ...newOptions[index],
        additionUid: addition.uid
      }
      if(newCounter==0)
      handlerOnChanges('add',ad);
      else handlerOnChanges('update',ad);
    }
    //console.debug('handlerOnAddOption, getCounterOptions:',options.current);
    counter = getCounterOptions(options.current)
    setDisableOptions(counter>=maxChecks); 
  }

  const handlerOnRemoveOption = (option,index)=>{
    //console.debug('handlerOnRemoveOption:',index);

    let newCounter = option.counter ? option.counter:0; 
    if(newCounter>0){
      newCounter--; 
    }

    const newOptions = [...options.current]; 
    newOptions[index]={
      ...option, 
      counter: newCounter
    }
    options.current = newOptions;
    const ad = {
      ...newOptions[index],
      additionUid: addition.uid
    }
    if(newCounter==0)
      handlerOnChanges('remove',ad);
    else  handlerOnChanges('update',ad);
    //console.debug('handlerOnRemoveOption, getCounterOptions:',options.current);
    const counter = getCounterOptions(options.current)
    setDisableOptions(counter>=maxChecks); 
  }


  return (
    <div className={classes.content}>  
       <div className={classes.title}>  
          <Typography variant="subtitle1">   {addition.name}</Typography>
          <div className={classes.maximun}>
          <Typography variant="body2"  color="text.muted">   {maxStr}</Typography>
          {addition.type == "REQUIRED" && 
          <Chip label={strings.additions_required} color={getColorRequired(options.current)} size="small"   />
          }
          </div>
          
      </div>

      <List>
          {
           options.current.map((element,index)=>(
          
            <ListItem key={element.uid} className={classes.listItem}>
       
              <div className={classes.optionText}>
                <Typography  variant ={getVariant(getStatus(element))}
                              color ={getOptionColor(getStatus(element))}> {element.name} </Typography>
                <Typography  ml={1} variant ={getVariant(getStatus(element))} 
                            color ={getExtraPriceColor(getStatus(element))}> {getExtraPrice(element)}
                </Typography>
              </div>

              <div className={classes.counter}>
                  { element.counter && element.counter>0 ?
                    <Paper className={classes.paper} elevation={2}>
                        <IconButton aria-label="remove" size='small'  onClick={( )=>handlerOnRemoveOption(element,index)}>
                        <RemoveIcon />
                        </IconButton>
                    </Paper>
                    :""
                  }
                  { element.counter && element.counter>0 ? 
                   <Typography  variant ={getVariant(getStatus(element))} ml={1} mr={1}
                   color ={getOptionColor(getStatus(element))}> {element.counter} </Typography>
                  :""
                  }
                
                  <Paper className={classes.paper} elevation={2}>
                      <IconButton aria-label="add"  size='small' onClick={( )=>handlerOnAddOption(element,index)}>
                      <AddIcon />
                      </IconButton>
                  </Paper>
              </div>
            </ListItem>
          ))
          }
    </List>
    </div>
  );
}
